import i18n from 'i18next';

import { createPasswordFields } from './create-password-fields';
import errors from './errors';
import fields from './fields';
import { logout } from './logout';
import navBar from './navbar';
import { passwordRecovery } from './passwordRecovery';
import passwordStreight from './passwordStreight';
import { redirect } from './redirect';
import { requestEmailPageForm } from './request-email-page-form';
import { requestResetPassord } from './request-reset-password';
import { requestSignInOtp } from './request-sign-in-otp';
import { signin } from './signin';
import { signup } from './signup';
import { corporateLogin } from './corporateLogin';
import { userChallenge } from './userchallenge';
import { verificationCode } from './verification-code';
import { wrapperPage } from './wrapper-page';
import { unsubscribe } from './unsubscribe';

const addResource = (nameSpace: string, resource: any) => {
  i18n.addResourceBundle('pt-BR', `ns_${nameSpace}`, resource, true, true);
};

const Resources = () => {
  addResource('signin', signin);
  addResource('corporateLogin', corporateLogin);
  addResource('signup', signup);
  addResource('userChallenge', userChallenge);
  addResource('navBar', navBar);
  addResource('passwordRecovery', passwordRecovery);
  addResource('passwordStreight', passwordStreight);
  addResource('fields', fields);
  addResource('redirect', redirect);
  addResource('errors', errors);
  addResource('logout', logout);
  addResource('wrapper-page', wrapperPage);
  addResource('createPasswordFields', createPasswordFields);
  addResource('verification-code', verificationCode);
  addResource('request-email-page-form', requestEmailPageForm);
  addResource('request-reset-password', requestResetPassord);
  addResource('request-sign-in-otp', requestSignInOtp);
  addResource('unsubscribe', unsubscribe);
};

export default Resources;
